const MOBILE_VIEW_MAX_WIDTH = 768
const SWIPE_THRESHOLD = 40
const sections = document.querySelectorAll('.product-feed-slider')

sections.forEach((section) => {
  let isTransitioning = false
  const cards = section.querySelectorAll('.product-feed-slider__card')
  const sliderContainer = section.querySelector('.product-feed-slider__container')
  let isMobileView = window.innerWidth <= MOBILE_VIEW_MAX_WIDTH

  const resizeObserver = new ResizeObserver(() => {
    const wasDesktopView = !isMobileView
    isMobileView = window.innerWidth <= MOBILE_VIEW_MAX_WIDTH

    // If transitioning from desktop to mobile, reset to first card
    if (wasDesktopView && isMobileView) {
      const inner = section.querySelector('.product-feed-slider__inner')
      const allCards = Array.from(inner.children)
      const firstCard = allCards[0]

      if (!firstCard) return

      inner.style.transition = 'none'
      inner.style.transform = 'translateX(0)'

      allCards.forEach((card, index) => {
        card.dataset.blockIndex = index
        if (index === 0) {
          card.setAttribute('data-selected', '')
        } else {
          card.removeAttribute('data-selected')
        }
      })

      section.dataset.selectedBlockIndex = '0'
      section.style.height = ''
      isTransitioning = false

      void inner.offsetHeight
      inner.style.transition = ''
    }
  })
  resizeObserver.observe(section)

  function swapCards(clickedCard, selectFirst = false) {
    const clickedProductId = parseInt(clickedCard.dataset.blockIndex)
    const selectedCard = section.querySelector('[data-selected]')
    const selectedCardId = parseInt(selectedCard.dataset.blockIndex)

    if ((clickedProductId === selectedCardId || isTransitioning) && !selectFirst) return false
    section.style.height = section.offsetHeight + 'px'

    section.dataset.selectedBlockIndex = clickedCard.dataset.blockIndex
    selectedCard.removeAttribute('data-selected')
    clickedCard.setAttribute('data-selected', '')

    if (isMobileView) {
      isTransitioning = true

      const selectedCardRect = selectedCard.getBoundingClientRect()
      const clickedCardRect = clickedCard.getBoundingClientRect()
      const scrollOffset = clickedCardRect.right - selectedCardRect.left - selectedCardRect.width

      const inner = section.querySelector('.product-feed-slider__inner')
      inner.style.transform = `translateX(-${scrollOffset}px)`

      // Handle infinite carousel rearrangement
      const transitionHandler = () => {
        try {
          const selectedCard = section.querySelector('[data-selected]')
          const clickedCardIndex = parseInt(selectedCard.dataset.blockIndex)
          const allCards = Array.from(inner.children)
          const cardsToMove = allCards.slice(0, clickedCardIndex)

          if (cardsToMove.length > 0) {
            // Disable transitions temporarily
            inner.style.transition = 'none'

            // Move cards that were before selected card to the end
            cardsToMove.forEach((card) => {
              inner.appendChild(card)
            })

            inner.style.transform = 'translateX(0)'

            // Update block indices
            Array.from(inner.children).forEach((card, index) => {
              card.dataset.blockIndex = index
            })

            // Update section's selected block index to 0 since selected card is now first
            section.dataset.selectedBlockIndex = '0'

            // Force reflow to apply position changes, then re-enable transitions
            void inner.offsetHeight
            inner.style.transition = ''
          }
        } finally {
          isTransitioning = false
        }
      }

      section.addEventListener('transitionend', transitionHandler, { once: true })
    }

    section.addEventListener(
      'transitionend',
      () => {
        section.style.height = ''
      },
      { once: true }
    )

    return true
  }

  function getAdjacentCard(direction) {
    const inner = section.querySelector('.product-feed-slider__inner')
    const allCards = Array.from(inner.children)

    if (allCards.length < 2) return null

    const selectedCard = section.querySelector('[data-selected]')
    const selectedCardIndex = allCards.indexOf(selectedCard)

    if (selectedCardIndex < 0) return null

    if (direction === 'next') {
      return allCards[(selectedCardIndex + 1) % allCards.length]
    }

    return allCards[(selectedCardIndex - 1 + allCards.length) % allCards.length]
  }

  function swipeToPreviousCard() {
    if (!isMobileView || isTransitioning) return false

    const inner = section.querySelector('.product-feed-slider__inner')
    const allCards = Array.from(inner.children)

    if (allCards.length < 2) return false

    const selectedCard = section.querySelector('[data-selected]')
    const previousCard = allCards[allCards.length - 1]
    const previousCardWidth = previousCard.getBoundingClientRect().width

    section.style.height = section.offsetHeight + 'px'
    isTransitioning = true

    // Keep the viewport visually stable while prepending the previous card.
    inner.style.transition = 'none'
    inner.insertBefore(previousCard, inner.firstChild)
    inner.style.transform = `translateX(-${previousCardWidth}px)`

    Array.from(inner.children).forEach((card, index) => {
      card.dataset.blockIndex = index
    })

    // At this stage selected card is second and remains large until the back animation runs.
    section.dataset.selectedBlockIndex = selectedCard.dataset.blockIndex

    void inner.offsetHeight
    inner.style.transition = ''

    selectedCard.removeAttribute('data-selected')
    previousCard.setAttribute('data-selected', '')
    section.dataset.selectedBlockIndex = previousCard.dataset.blockIndex

    requestAnimationFrame(() => {
      inner.style.transform = 'translateX(0)'
    })

    const onInnerTransitionEnd = (event) => {
      if (event.target !== inner || event.propertyName !== 'transform') return

      inner.removeEventListener('transitionend', onInnerTransitionEnd)
      isTransitioning = false
      section.style.height = ''
    }

    inner.addEventListener('transitionend', onInnerTransitionEnd)

    return true
  }

  if (sliderContainer) {
    let touchStartX = null
    let touchStartY = null
    let suppressClick = false
    let suppressClickTimeoutId = null

    sliderContainer.addEventListener(
      'touchstart',
      (event) => {
        if (!isMobileView || event.touches.length !== 1) {
          touchStartX = null
          touchStartY = null
          return
        }

        touchStartX = event.touches[0].clientX
        touchStartY = event.touches[0].clientY
      },
      { passive: true }
    )

    sliderContainer.addEventListener(
      'touchend',
      (event) => {
        if (!isMobileView || event.changedTouches.length !== 1 || touchStartX === null || touchStartY === null) {
          touchStartX = null
          touchStartY = null
          return
        }

        const touchEndX = event.changedTouches[0].clientX
        const touchEndY = event.changedTouches[0].clientY
        const deltaX = touchEndX - touchStartX
        const deltaY = touchEndY - touchStartY

        touchStartX = null
        touchStartY = null

        const isHorizontalSwipe = Math.abs(deltaX) >= SWIPE_THRESHOLD && Math.abs(deltaX) > Math.abs(deltaY)

        if (!isHorizontalSwipe) return

        let didNavigate = false
        if (deltaX < 0) {
          const targetCard = getAdjacentCard('next')
          if (targetCard) didNavigate = swapCards(targetCard)
        } else {
          didNavigate = swipeToPreviousCard()
        }

        if (didNavigate) {
          suppressClick = true

          if (suppressClickTimeoutId) {
            clearTimeout(suppressClickTimeoutId)
          }

          suppressClickTimeoutId = setTimeout(() => {
            suppressClick = false
            suppressClickTimeoutId = null
          }, 350)
        }
      },
      { passive: true }
    )

    sliderContainer.addEventListener(
      'touchcancel',
      () => {
        touchStartX = null
        touchStartY = null
      },
      { passive: true }
    )

    sliderContainer.addEventListener(
      'click',
      (event) => {
        if (!suppressClick) return

        event.preventDefault()
        event.stopPropagation()
      },
      true
    )
  }

  cards.forEach((card) => {
    const link = card.querySelector('.product-feed-slider__card-link')

    if (link) {
      link.addEventListener('click', (e) => {
        const selectedCard = section.querySelector('[data-selected]')
        const isAlreadySelected = card === selectedCard

        if (!isAlreadySelected) {
          e.preventDefault()
          swapCards(card)
        }
        // If already selected, allow default link navigation to product page
      })
    }
  })
})
